(() => {
  const initPoVideoController = () => {
    const videoWrappers = document.querySelectorAll('po-video-with-thumbnail');

    videoWrappers.forEach(wrapper => {
      const video = wrapper.querySelector('video');
      const controller = wrapper.querySelector('.po-video-controller');
      const thumbnailController = wrapper.querySelector('.tw-po-video-thumbnail-controller');

      if (!video || !controller || !thumbnailController) return;

      const show = (el) => {
        el.classList.remove('tw-opacity-0');
        el.classList.add('tw-opacity-100');
      };

      const hide = (el) => {
        el.classList.add('tw-opacity-0');
        el.classList.remove('tw-opacity-100');
      };

      video.addEventListener('ended', () => {
        hide(controller);
        hide(thumbnailController);
      });

      wrapper.addEventListener('mouseenter', () => {
        show(controller);
        show(thumbnailController);
      });

      wrapper.addEventListener('mouseleave', () => {
        hide(controller);
        hide(thumbnailController);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPoVideoController);
  } else {
    initPoVideoController();
  }
})();
